// extracted by mini-css-extract-plugin
var _1 = "gGjqt4WPonIYxLFfSyfP";
var _2 = "gGjqt4WPonIYxLFfSyfP";
export { _1 as "back-button", _2 as "backButton" }
